import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import * as proyectAction from '../../store/actions/proyectAction';
import AppSubmenu from './AppSubMenu';

class AppMenu extends Component {
  static defaultProps = {
    model: null,
    onMenuItemClick: null,
  };

  static propTypes = {
    model: PropTypes.array,
    onMenuItemClick: PropTypes.func,
  };
  render() {
    return (
      <div className="layout-menu-container">
        <AppSubmenu
          items={this.props.model}
          className="layout-menu"
          onMenuItemClick={this.props.onMenuItemClick}
          root={true}
        />
      </div>
    );
  }
}

const mapStateToProps = rootReducer => {
  return { global: rootReducer.proyect };
};

export default connect(
  mapStateToProps,
  proyectAction,
)(withTranslation('translations')(AppMenu));
